<template>
  <div class="ev-add-wrap">
    <AError :api="apiSubmit" />

    <!-- Alert Banner -->
    <AAlertBanner variant="danger" :messages="alertError" title="Warning" />

    <!-- Confirm Dialog -->
    <v-dialog v-model="eventCategoryDialog" max-width="380" content-class="confirm-dialog">
      <div class="confirm-card">
        <h3 class="confirm-card__title">Add Event Category</h3>
        <p class="confirm-card__message">Please confirm that you wish to Add New Event Category?</p>
        <div class="confirm-card__actions">
          <button class="confirm-card__btn confirm-card__btn--cancel" @click="eventCategoryDialog = false">
            Cancel
          </button>
          <button class="confirm-card__btn confirm-card__btn--confirm" @click="addNewEventCategory()">
            Confirm
          </button>
        </div>
      </div>
    </v-dialog>

    <!-- Sub-Header with Back -->
    <div class="ev-sub-header">
      <div class="ev-sub-header__left">
        <button class="ev-back-btn" @click="toggleEventCategoryPage()">
          <v-icon size="16" color="var(--app-text-muted)">mdi-arrow-left</v-icon>
        </button>
        <h2 class="ev-sub-header__title">Add Event Category</h2>
      </div>
    </div>

    <!-- Form Card -->
    <div class="ev-form-card">
      <div class="ev-form-card__section-label">
        <v-icon size="16" color="var(--app-accent)" class="mr-2">mdi-shape-plus</v-icon>
        Category Details
      </div>
      <div class="ev-form-card__divider"></div>

      <div class="ev-form-card__body">
        <!-- Category -->
        <div class="ev-form-group">
          <label class="ev-form-group__label">Category</label>
          <v-text-field
            dense
            outlined
            placeholder="e.g. E-INVOICING CONFERENCE 2024"
            v-model="formData.eventCategory"
            :error-messages="errorField.eventCategory"
            hide-details="auto"
            class="ev-form-input"
          ></v-text-field>
        </div>

        <!-- Submit -->
        <div class="ev-form-card__actions">
          <button
            class="ev-submit-btn"
            @click="eventCategoryDialog = true"
            :disabled="apiSubmit.isLoading"
          >
            <v-icon size="16" color="#fff" class="mr-2">mdi-content-save-outline</v-icon>
            Save Category
          </button>
        </div>
      </div>
    </div>

    <HrdcLoader :loadingDialog="loadingDialog"></HrdcLoader>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc_event/objects/globalData";

export default {
  mixins: [hrdcFunction],
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  props: ["params"],
  emits: ["toggleEventCategoryPage"],
  data: () => ({
    apiSubmit: new Api(),
    model: new Model(),
    service: new Service(),
    hrdcData: new HrdcData(),
    alertError: [],
    formData: {
      eventCategory: null,
    },
    errorField: {
      eventCategory: null,
    },
    loadingDialog: false,
    eventCategoryDialog: false,
    editMode: false,
    btnDisabled: false,
    eventType: null,
    eventCategoriesData: [],
  }),
  async created() {
    this.showLoadingDialog();

    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    const eventTypeMap = require("@/services/hrdc_event/eventRegistry").getEventTypeMap();
    this.eventType = eventTypeMap[this.service.key] || null;

    // Assign apiDetails by mapping repository.
    const apiDetails = {
      apiSubmit: {
        url: `${
          this.$service[this.service.key]
        }/v1/en/console/settings/event/create-event-category`,
        method: "post",
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    //EOC
    this.stages = await this.hrdcData.allStages;
    this.rolesAssignation(this.auth.roles);
    if (!this.isHrdcSuperAdminRoles) {
      this.alertError.push("You are not allowed to perform this action!");
      this.btnDisabled = true;
    }

    this.hideLoadingDialog();
  },
  methods: {
    clearErrorMsg() {
      for (let error in this.errorField) {
        this.errorField[error] = null;
      }
    },
    showErrorMessage(response) {
      for (const key in response.data) {
        this.errorField[key] = null;
        this.errorField[key] = response.data[key];
      }
    },
    addNewEventCategory() {
      this.eventCategoryDialog = !this.eventCategoryDialog;
      this.submit();
    },
    toggleEventCategoryPage() {
      this.$emit("toggleEventCategoryPage", "EventCategoryIndex");
    },
    redirectBack() {
      let route = this.eventRoute("Application");
      if (this.params.backTo) {
        route = this.params.backTo;
      }

      this.$store.commit("assignDeveloperData", {
        paginationPageNo: this.$route.query.currentPageNo,
      });

      this.$router.push({
        name: route,
        params: {
          modelKey: this.model.key,
          backTo: "",
        },
        query: {
          viewId: this.$store.state[this.service.key].data.viewId,
        },
      });
    },
    async submit() {
      this.showLoadingDialog();

      this.apiSubmit.setParams({
        eventCategory: this.formData.eventCategory,
        eventType: this.eventType,
      });
      this.apiSubmit.setCallbackCompleted((response) => {
        try {
          this.clearErrorMsg();
          if (!response.status) {
            this.showErrorMessage(response);
            this.$store.dispatch("showMessage", {
              message: "Please fill in all the required fields",
              messageType: "error",
              timeout: 2000,
            });
          }

          if (response.status) {
            this.$store.commit("assignDeveloperData", {
              paginationPageNo: this.$route.query.currentPageNo,
            });

            this.$emit("toggleEventCategoryPage", "EventCategoryIndex");
            this.$store.dispatch("showMessage", {
              message: response.data,
              messageType: "success",
              timeout: 2000,
            });
          }
        } catch (err) {
          console.log(err);
        }
      });
      this.apiSubmit.fetch();
      this.hideLoadingDialog();
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .ev-back-btn {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border);
}

.dark-mode .ev-back-btn:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

.dark-mode .ev-sub-header__title {
  color: var(--app-text);
}

.dark-mode .ev-form-card {
  background: var(--app-form-tile);
  border: 1px solid var(--app-border);
}

.dark-mode .ev-form-card__section-label {
  color: var(--app-neutral-fg);
}

.dark-mode .ev-form-card__divider {
  background: var(--app-form-tile);
}

.dark-mode .ev-form-card__actions {
  border-top: 1px solid var(--app-border);
}

.dark-mode .ev-form-group__label {
  color: var(--app-text);
}

.dark-mode .ev-modal {
  background: var(--app-card);
}

.dark-mode .ev-modal__confirm-icon {
  background: var(--app-accent-soft);
}

.dark-mode .ev-modal__heading {
  color: var(--app-text);
}

.dark-mode .ev-modal__message {
  color: var(--app-text-muted);
}

.dark-mode .ev-modal__footer {
  border-top: 1px solid var(--app-border);
}

.dark-mode .ev-modal__btn--outlined {
  background: var(--app-form-tile);
  color: var(--app-text-muted);
  border: 1.5px solid var(--app-border);
}

.dark-mode .ev-modal__btn--outlined:hover {
  background: var(--app-form-tile-hover);
  border-color: var(--app-border-strong);
}

/* >>> end auto-dark <<< */

/* ============================================
   ADD WRAPPER
   ============================================ */
.ev-add-wrap {
  padding: 24px;
  font-family: 'Lato', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ============================================
   SUB-HEADER
   ============================================ */
.ev-sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.ev-sub-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ev-back-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ev-back-btn:hover {
  background: #e2e8f0;
  border-color: #cbd5e1;
  transform: translateX(-2px);
}

.ev-sub-header__title {
  font-size: 1.05rem;
  font-weight: 800;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.2px;
}

/* ============================================
   FORM CARD
   ============================================ */
.ev-form-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.ev-form-card__section-label {
  display: flex;
  align-items: center;
  padding: 14px 24px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ev-form-card__divider {
  height: 1px;
  background: #e2e8f0;
}

.ev-form-card__body {
  padding: 24px;
}

.ev-form-card__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f1f5f9;
}

/* ============================================
   FORM GROUPS
   ============================================ */
.ev-form-group {
  margin-bottom: 18px;
}

.ev-form-group__label {
  display: block;
  font-family: 'Lato', sans-serif;
  font-size: 0.78rem;
  font-weight: 700;
  color: #374151;
  margin-bottom: 6px;
}

/* ============================================
   SUBMIT BUTTON
   ============================================ */
.ev-submit-btn {
  display: inline-flex;
  align-items: center;
  padding: 10px 24px;
  border-radius: 10px;
  background: #0ea5e9;
  color: #fff;
  font-family: 'Lato', sans-serif;
  font-size: 0.84rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(14, 165, 233, 0.2);
}

.ev-submit-btn:hover {
  background: #0284c7;
  box-shadow: 0 4px 16px rgba(14, 165, 233, 0.3);
  transform: translateY(-1px);
}

.ev-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* ============================================
   MODAL / DIALOG
   ============================================ */
.ev-modal {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.ev-modal__body {
  padding: 24px;
}

.ev-modal__body--center {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px 24px;
}

.ev-modal__confirm-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #e0f2fe;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.ev-modal__heading {
  font-family: 'Lato', sans-serif;
  font-size: 1.05rem;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 8px;
}

.ev-modal__message {
  font-family: 'Lato', sans-serif;
  font-size: 0.88rem;
  font-weight: 500;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

.ev-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
}

.ev-modal__btn {
  display: inline-flex;
  align-items: center;
  padding: 9px 20px;
  border-radius: 10px;
  font-size: 0.84rem;
  font-weight: 700;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
}

.ev-modal__btn--outlined {
  background: #fff;
  color: #64748b;
  border: 1.5px solid #e2e8f0;
}

.ev-modal__btn--outlined:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.ev-modal__btn--primary {
  background: #0ea5e9;
  color: #fff;
  box-shadow: 0 2px 8px rgba(14, 165, 233, 0.2);
}

.ev-modal__btn--primary:hover {
  background: #0284c7;
  box-shadow: 0 4px 16px rgba(14, 165, 233, 0.3);
}

/* ============================================
   TRANSITIONS
   ============================================ */
.slide-fade-enter-active { transition: all 0.3s ease; }
.slide-fade-leave-active { transition: all 0.2s ease; }
.slide-fade-enter { transform: translateY(-8px); opacity: 0; }
.slide-fade-leave-to { transform: translateY(-4px); opacity: 0; }

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 768px) {
  .ev-add-wrap { padding: 16px; }
  .ev-form-card__body { padding: 20px 16px; }
}

/* ============================================
   DARK MODE
   ============================================ */
.dark-mode .ev-sub-header__title { color: var(--app-text); }
.dark-mode .ev-back-btn { background: var(--app-border); border-color: var(--app-border-strong); }
.dark-mode .ev-back-btn:hover { background: var(--app-border-strong); }
.dark-mode .ev-form-card { background: var(--app-form-tile); border-color: var(--app-border); }
.dark-mode .ev-form-card__section-label { color: var(--app-text-muted); }
.dark-mode .ev-form-card__divider { background: var(--app-border); }
.dark-mode .ev-form-group__label { color: var(--app-neutral-fg); }
.dark-mode .ev-form-card__actions { border-color: var(--app-border); }
.dark-mode .ev-modal { background: var(--app-card); }
.dark-mode .ev-modal__heading { color: var(--app-text); }
.dark-mode .ev-modal__message { color: var(--app-text-muted); }
.dark-mode .ev-modal__footer { border-color: var(--app-border); }

</style>

<style>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .ev-form-input.v-text-field--outlined fieldset {
  border-color: var(--app-field-border) !important;
}

.dark-mode .ev-form-input.v-text-field--outlined:hover fieldset {
  border-color: var(--app-field-border-hover) !important;
}

/* >>> end auto-dark <<< */

/* Form input overrides */
.ev-form-input.v-text-field--outlined fieldset {
  border-color: #e2e8f0 !important;
}
.ev-form-input.v-text-field--outlined:hover fieldset {
  border-color: #cbd5e1 !important;
}
.ev-form-input.v-input--is-focused fieldset {
  border-color: #0ea5e9 !important;
  border-width: 2px !important;
}

.ev-modal-overlay {
  box-shadow: none !important;
  border-radius: 20px !important;
  overflow: hidden;
}
</style>
